import * as React from "react";
import QuestionLabel from "./QuestionLabel";
import QuestionError from "./QuestionError";
import StoreContainer from "../../../stores/StoreContainer";
import getControlProps from "../helpers/getControlProps";

interface ClickToCallQuestionProps {
  onChange: any;
  question: any;
  answer: any;
  error: string;
}

const ClickToCallOptions = {
  Call: "Call",
  Chat: "Chat"
};

class ClickToCallQuestion extends React.Component<
  ClickToCallQuestionProps,
  {}
> {
  onChange = (e: React.FormEvent<HTMLSelectElement>) => {
    const isClickToCall = e.currentTarget.value === ClickToCallOptions.Call;
    StoreContainer.SettingStore.setClickToCall(isClickToCall);
    this.props.onChange(this.props.question, e.currentTarget.value);
  };

  render() {
    const config = StoreContainer.SettingStore.getConfig();
    if (config && config.CallsEnabled === false) {
      return null;
    }

    return (
      <div>
        <QuestionLabel question={this.props.question} />
        <select
          value={this.props.answer || ""}
          onChange={this.onChange}
          {...getControlProps(this.props.question, this.props.error)}
        >
          <option />
          <option value={ClickToCallOptions.Chat}>
            {ClickToCallOptions.Chat}
          </option>
          <option value={ClickToCallOptions.Call}>
            {ClickToCallOptions.Call}
          </option>
        </select>
        <QuestionError
          questionId={this.props.question.QuestionID}
          error={this.props.error}
        />
      </div>
    );
  }
}

export default ClickToCallQuestion;
